import { UseMutateFunction } from 'react-query';
import { QueriesTypes, useDeleteRequest, useGetRequest, usePostRequest } from '../../../common/hooks/queries';

export const useCorrespondenciasRolex = (): [any[], boolean, boolean] => {
  const { data, isLoading, isError } = useGetRequest(QueriesTypes.RolexCorrespondencias);
  return [data, isLoading, isError];
};

export const useCreateCorrealacaoRolex = (): [
  UseMutateFunction<
    any,
    unknown,
    {
      requestPayload: {
        [key: string]: any;
      };
      queryParams?: { clientId?: string | number; step?: number } | undefined;
    }
  >,
  boolean,
  boolean
] => {
  const { isLoading, isError, mutate } = usePostRequest(QueriesTypes.RolexCorrespondencias);
  return [mutate, isLoading, isError];
};

export const useDeleteCorrespondenciaRolex = (): [
  UseMutateFunction<
    any,
    unknown,
    {
      id?: string | number;
    },
    unknown
  >,
  boolean,
  boolean
] => {
  const { isLoading, isError, mutate } = useDeleteRequest(QueriesTypes.RolexCorrespondencias);
  return [mutate, isLoading, isError];
};

export const useCorrespondenciaDetalhesRolex = (correspondenciaPaiId: string): [any[], boolean, boolean] => {
  const { data, isLoading, isError } = useGetRequest(QueriesTypes.RolexCorrespondenciasDetalhes, correspondenciaPaiId);
  return [data, isLoading, isError];
};

export const useCreateCorrespondenciaDetalheRolex = (): [
  UseMutateFunction<any, unknown, { requestPayload: { [key: string]: any } }>,
  boolean,
  boolean
] => {
  const { isLoading, isError, mutate } = usePostRequest(QueriesTypes.RolexCorrespondenciasDetalhes);
  return [mutate, isLoading, isError];
};

export const useDeleteCorrespondenciaDetalheRolex = (): [
  UseMutateFunction<any, unknown, { id: string | number }>,
  boolean,
  boolean
] => {
  const { isLoading, isError, mutate } = useDeleteRequest(QueriesTypes.RolexCorrespondenciasDetalhes);
  return [mutate as UseMutateFunction<any, unknown, { id: string | number }>, isLoading, isError];
};